// extracted by css-extract-rspack-plugin
export default {"root":"src-components-UI-LoadingDots-module__root-GXMR6U","dots":"src-components-UI-LoadingDots-module__dots-uzrOWK","dot":"src-components-UI-LoadingDots-module__dot-ShZ_yz","loadingDotPulse":"src-components-UI-LoadingDots-module__loadingDotPulse-WyG1dH"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"root\":\"src-components-UI-LoadingDots-module__root-GXMR6U\",\"dots\":\"src-components-UI-LoadingDots-module__dots-uzrOWK\",\"dot\":\"src-components-UI-LoadingDots-module__dot-ShZ_yz\",\"loadingDotPulse\":\"src-components-UI-LoadingDots-module__loadingDotPulse-WyG1dH\"}";
        // 1790730173187
        var cssReload = require("../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  